import { motion, useScroll, useSpring } from "framer-motion";
import styled from "styled-components";
import { GREEN } from "../constants/theme";

const Bar = styled(motion.div)`
  position: fixed;
  inset: 0 auto auto 0;
  right: 0;
  height: 4px;
  transform-origin: left;
  z-index: 60;
  background: ${GREEN};
`;

export default function ProgressBar() {
  const { scrollYProgress } = useScroll();
  const scaleX = useSpring(scrollYProgress, {
    stiffness: 120,
    damping: 24,
    mass: 0.4,
  });
  return <Bar style={{ scaleX }} />;
}
